import React from 'react'

const e = React.createElement;


function GraphHours(props) {
  React.Component.constructor.call(this);

  this.state = {graph_offset:null};
}
GraphHours.prototype = Object.create(React.Component.prototype);


GraphHours.prototype.componentDidUpdate = function() {
  var canvas_wrapper = document.getElementById("graphhours-wrapper");
  var canvas = document.getElementById("canvashours");
  if(this.state.graph_offset === null && canvas_wrapper && canvas && canvas.width > 0) {
    var max_width = canvas_wrapper.offsetWidth;
    var new_graph_offset = -(canvas.width - max_width);
    this.setState({graph_offset:new_graph_offset});
  }
}

GraphHours.prototype.render = function() {
  const data = this.props.data;
  const filtered = this.props.filtered ? this.props.filtered : null;
  var canvas = document.getElementById("canvashours");

  if(canvas && data[0] !== undefined) {
    var ctx = canvas.getContext("2d");

    var now = new Date();
    var last_date = new Date(data[0].created_on);
    var d2 = last_date;
    var ignored_date = false;
    if(now.getFullYear()+"-"+(now.getMonth()+1)+"-"+now.getDate() === last_date.getFullYear()+"-"+(last_date.getMonth()+1)+"-"+last_date.getDate()) {
      d2 = new Date(last_date.getTime()-(86400000)); // 24hrs in milliseconds
      ignored_date = last_date.getFullYear()+"-"+(last_date.getMonth()+1)+"-"+last_date.getDate();
    }
    var last_key = d2.getFullYear()+"-"+(d2.getMonth()+1)+"-"+d2.getDate();

    var values = {};
    data.map(function(item, i) {
      if(filtered && item.app_id !== filtered) {return;}
      var d = new Date(item.created_on);
      if(ignored_date && d.getFullYear()+"-"+(d.getMonth()+1)+"-"+d.getDate() === ignored_date) {return;}
      var key = d.getHours();
      if(values[key] === undefined) {
        values[key] = 1;
      } else {
        values[key]++;
      }
    });

    var d = new Date(data[data.length - 1].created_on);

    var dates = {};
    for(var loop_stop = 0; loop_stop < 1;) {
      var key = d.getFullYear()+"-"+(d.getMonth()+1)+"-"+d.getDate();
      dates[key] = true;
      d.setDate(d.getDate() + 1);

      if(key === last_key) {
        loop_stop++;
      }
    }
    var days = Object.keys(dates).length

    var times = {};
    for(var h = 0;h < 24;h++) {
      if(values[h]) {
        times[h] = (values[h] / days).toFixed(2); // .00
      } else {
        times[h] = 0;
      }
    }

    var max_value = 0.0;
    for(var i in times) {
      var times_i = parseFloat(times[i]);
      if(times_i > max_value) max_value = times_i;
    }

    canvas.width = Object.keys(times).length * 37 + 6;

    ctx.fillStyle = "#222222";
    ctx.textAlign = "center";
    var dates_i = 0;
    for(var key in times) {
      if(times[key] !== 0) {
        var perc = Math.floor(times[key] / max_value * 100);
        ctx.fillRect(6+dates_i*37, 100-perc, 35, perc);

        ctx.fillStyle = "#FF669E";
        ctx.fillText(times[key], 23+dates_i*37, 94);
      }

      ctx.fillStyle = "#222222";
      ctx.fillText(key, 23+dates_i*37, 110);

      dates_i++;
    }
  } else if(!canvas) {
    setTimeout(function() {
      this.setState({reload:true});
    }.bind(this), 0);
  }

  return e('div', {className:"card"}, e('div', {id:"graphhours-wrapper", style:{overflow:"hidden"}}, [
    e('span', {key:"left", className:"graph-arrow", onClick:this.moveGraph.bind(this, false)}, "<"),
    e('span', {key:"right", className:"graph-arrow", onClick:this.moveGraph.bind(this, true), style:{marginLeft:"22px"}}, ">"),
    e('span', {key:"max", style:{float:"right", fontSize:"62%", opacity:".4"}}, max_value && "max. "+max_value),
    e('canvas', {key:"canvas", id:"canvashours", width:"0px", height:"120px", style:{marginLeft:this.state.graph_offset}})
  ]));
}

GraphHours.prototype.moveGraph = function(move_right) {
  var canvas_wrapper = document.getElementById("graphhours-wrapper");
  var max_width = canvas_wrapper.offsetWidth;
  var canvas = document.getElementById("canvashours");

  var new_offset = -120;
  var new_graph_offset = this.state.graph_offset;
  if(canvas.width > 0) {
    if(!move_right && new_graph_offset < 0) {
      new_graph_offset = this.state.graph_offset - new_offset;
      if(new_graph_offset > 0) new_graph_offset = 0;
    }
    if(move_right && canvas.width + this.state.graph_offset > max_width) {
      new_graph_offset = this.state.graph_offset + new_offset;
      if(canvas.width + new_graph_offset < max_width) new_graph_offset = -(canvas.width - max_width);
    }
  }
  this.setState({graph_offset:new_graph_offset});
}


export default GraphHours



//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/components/GraphHours.js
// module id = 191
// module chunks = 0